import React from 'react';
import { List, Card, Icon, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import formatter from 'utils/formatter';

export default function MenuProductsList({ menu, history, onRefresh }) {
  return menu.map((categoryProducts, index) => {
    const categoryName = categoryProducts[0];
    const products = categoryProducts[1];
    const categoryId = categoryProducts[2]; // Get category ID directly from the 3rd element
    
    return (
      <Card fluid key={index} style={{ boxShadow: 'none', border: 'none', borderBottom: '1px solid #eee', marginBottom: '24px' }}>
        <Card.Content style={{ padding: '16px 8px' }}>
          <Card.Header style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            fontSize: '1.6em',
            fontWeight: 'bold',
            marginBottom: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {categoryName}
              {categoryId && (
                <Button 
                  size="tiny" 
                  icon 
                  circular
                  as={Link}
                  to={`/menu/categories/edit/${categoryId}`}
                  style={{ marginLeft: '8px' }}
                >
                  <Icon name="pencil" />
                </Button>
              )}
            </div>
            <div>
              {categoryId && (
                <Button 
                  size="tiny" 
                  icon 
                  circular 
                  primary
                  as={Link}
                  to={`/menu/products/new?categoryId=${categoryId}`}
                >
                  <Icon name="plus" />
                </Button>
              )}
            </div>
          </Card.Header>
          
          {products.length > 0 ? (
            <List divided relaxed>
              {products.map((product) => (
                <List.Item
                  key={product.id}
                  as={Link}
                  to={`/menu/products/${product.id}`}
                  style={{ 
                    padding: '16px 8px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    textDecoration: 'none', 
                    color: 'inherit' 
                  }}
                >
                  <List.Content style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <List.Header style={{ fontSize: '1.6em', fontWeight: 'normal' }}>
                        {product.name}
                      </List.Header>
                      {!product.hasOwnProperty('cost') || product.cost === null || product.cost === undefined || product.cost === '' ? (
                        <Icon 
                          name="warning sign" 
                          color="orange" 
                          size="large" 
                          style={{ marginLeft: '8px', marginTop: '4px' }} 
                          title="Falta agregar costo"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Product with missing cost:', product);
                          }}
                        />
                      ) : null}
                    </div>
                  </List.Content>
                  <Icon name="chevron right" color="grey" />
                </List.Item>
              ))}
            </List>
          ) : (
            <div style={{ padding: '16px 0', color: '#666', fontSize: '1.3em' }}>
              No hay productos en esta categoría.
            </div>
          )}

        </Card.Content>
      </Card>
    );
  });
}